var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-barcode-scanner"
  }, [_c('div', [_vm.provider === _vm.PROVIDER.SCANDIT ? _c('Scandit', {
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    }
  }) : _vm._e(), _vm.provider === _vm.PROVIDER.DYNAMSOFT ? _c('Dynamsoft', {
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    }
  }) : _vm._e(), _vm.provider === _vm.PROVIDER.HTML5QRCODE ? _c('HTML5QRcode', {
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }